// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"D4-z"};